(function () {
  'use strict';

  /* --- Respect prefers-reduced-motion --- */
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealAll() {
    document.querySelectorAll('.pdp-reveal:not(.is-in)').forEach(function (el) {
      el.classList.add('is-in');
    });
  }

  if (reduceMotion || !('IntersectionObserver' in window)) {
    revealAll();
    return;
  }

  /* --- IntersectionObserver --- */
  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var delay = parseInt(el.dataset.revealDelay || '0', 10);
        if (delay > 0) {
          setTimeout(function () { el.classList.add('is-in'); }, delay);
        } else {
          el.classList.add('is-in');
        }
        io.unobserve(el);
      });
    },
    {
      threshold: 0.08,
      rootMargin: '0px 0px -40px 0px'
    }
  );

  function observe() {
    document.querySelectorAll('.pdp-reveal:not(.is-in)').forEach(function (el) {
      io.observe(el);
    });
  }

  /* Initial pass */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }

  /* Shopify Theme Editor: re-observe when sections load or reorder */
  document.addEventListener('shopify:section:load', observe);
  document.addEventListener('shopify:section:reorder', observe);

})();
